import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import { IndividualProfilePageComponent } from "./components/individual-profile-page/individual-profile-page.component";
import { IndividualsPageComponent } from "./components/individuals-page/individuals-page.component";

export function getIndividualsRoutes(): Route[] {
  return [
    {
      path: 'individuals',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [
        {
          title: 'Individuals',
          path: '',
          component: IndividualsPageComponent,
        },
        {
          title: 'Individual',
          path: ':id',
          component: IndividualProfilePageComponent,
        },
      ]
    }
  ];
}
